import { API } from './requests';
import { getCurrentEnv as getHost } from './helper';
export const isServer = !(typeof window !== 'undefined' && window.document);

export const getCurrentEnv = () => {
	const env = 'prod';
	if (!isServer) {
		const { host } = window.location;
		if (host.includes('dev.') || host.includes('localhost')) {
			return 'dev';
		}
		if (host.includes('stg.') || host.includes('stage.')) {
			return 'stage';
		}
	}
	return env;
};

export const getCurrentEnvBaseUrl = () => {
	const env = 'scintilla.com';
	if (!isServer) {
		const { host } = window.location;
		if (host.includes('dev.') || host.includes('localhost')) {
			return 'dev.scintilla.com';
		}
		if (host.includes('stg.') || host.includes('stage.')) {
			return 'stg.scintilla.com';
		}
	}
	return env;
};

export const getRunningEnv = () =>
	`${
		typeof process !== 'undefined' && process.env?.REACT_APP_ENV_HOST
			? process.env.REACT_APP_ENV_HOST
			: getCurrentEnv()
	}`;
export const routeToBaseApp = () => {
	window.location.href = `${window?.location?.protocol}//${window.location.host}`;
};
export const routeToApps = () => {
	window.location.href = `${window?.location?.protocol}//${window.location.host}/apps`;
};
export const getRedirectUrl = (currentUrl = '') => {
	const landings = {
		prod: 'https://www.scintilla.com',
		stage: 'https://stg.scintilla.com',
		dev: 'https://dev.scintilla.com',
	};
	const variables = {
		prod: `${landings?.prod}/login?lastUrl=${landings?.prod}${currentUrl}`,
		stage: `${landings?.stage}/login?lastUrl=${landings?.stage}${currentUrl}`,
		dev: `${landings?.dev}/login?lastUrl=${landings?.dev}${currentUrl}`,
	};
	return variables[getRunningEnv()];
};
export const routeToLogin = () => {
	window.location.href = getRedirectUrl(window?.location?.pathname);
};
export const getAxiosAuthHeader = (userInfo) => {
	const config = {};
	if (process.env.NODE_ENV === 'development') {
		let Authorization;
		if (userInfo) {
			if (getHost() === 'local') {
				Authorization = 'CATMAN_LOCALHOST_TESTING_TOKEN_123456789';
			}
		}
		config.headers = {
			Authorization,
			nocookie: 'abc',
			companyName: userInfo?.companyName || 'COLGATE-PALMOLIVE COMPANY',
		};
	} else {
		config.headers = {};
	}
	return config;
};
export const checkStatus = (resCode) => {
	if (
		resCode === API.RESPONSE.UNAUTHORIZED ||
		resCode === API.RESPONSE.FORBIDDEN
	) {
		localStorage.removeItem('selectedSubMenuKey');
		localStorage.removeItem('selectedMainMenuKey');
		routeToLogin(); // TODO: Fix from API side to avoid returning 401 and redirecting to login page
	}
};

export const getDimention = (hierarchyFilterRhid = '') => {
	let data = hierarchyFilterRhid?.split(',');
	let underScore = 0;
	for (let value of data) {
		const arrLen = value?.split('_');
		if (underScore < arrLen.length - 1) {
			underScore = arrLen.length - 1;
		}
	}

	if (underScore === 0) {
		return 'DEPARTMENT';
	} else if (underScore === 1) {
		return 'CATEGORY';
	} else {
		return 'SUB_CATEGORY';
	}
};

export const getmodifiedApiendpoint = (api, view) => {
	if (api?.includes('?')) {
		return api + '&personaView=' + view;
	} else {
		return api + '?personaView=' + view;
	}
};

export const getErrorMessage = (errorCode) => {
	switch (errorCode) {
		case 400:
			return 'Request is not well-formed, syntactically incorrect, or violates schema.';
		case 401:
			return 'Authentication failed due to missing Authorization header, or invalid authentication credentials.';
		case 403:
			return 'Authorization failed due to insufficient permissions.';
		case 404:
			return 'The specified resource does not exist.';
		case 405:
			return 'The server does not implement the requested HTTP method.';
		case 409:
			return 'The server has detected a conflict while processing this request.';
		case 415:
			return "The server does not support the request payload's media type.";
		case 412:
			return 'Update failed. Resource has changed on the server.';
		case 413:
			return 'The request entity is larger than the size limit defined by the server.';
		case 428:
			return 'This request must be conditional and requires a If-Match header.';
		case 429:
			return 'Too many requests. Blocked due to rate limiting.';
		case 500:
			return 'An internal server error has occurred.';
		case 503:
			return 'Service Unavailable.';
		case 1003:
			return 'Authorization failed due to insufficient permissions.';
		case 1004:
			return 'Connection timed out';
		default:
			return 'Try to reload the page or go back to Scintilla home.';
	}
};

export const checkUserAuth = (inputObject) => {
	let result = false;
	// Getting Products Array
	const productsArray = inputObject?.result?.products;

	// Accessing subApps array
	productsArray?.map((item) => {
		if (item?.code === 'CHANNEL_PERFORMANCE') {
			item?.subApps?.map((appItem) => {
				if (appItem?.code === 'CHANNEL_INSIGHTS') {
					result = true;
				}
			});
		}
	});

	return result;
};

export const removeSpecialCharacters = (text) => {
    return text.replace(/[:;='-/]/g, "")
} 